import { useState, useRef, useEffect, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import CustomButton from "../../components/CustomButton/CustomButton";
import InputField from "../../components/InputField/InputField";
import ModalWrapper from "../../components/Modal/ModalWrapper";
import PageHeader from "../../components/PageHeader/PageHeader";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { postDetails } from "../../services/http/http.service";
import { showLoader, hideLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import APIList from "../../utils/constants/APIList";
import { ModalRef } from "../../utils/constants/Interfaces.constants";
import setInputValues from "../../utils/helpers/setInputValue";
import {
  ArrowLeftSquareFill,
  Download,
  EyeFill,
  HandThumbsUp,
  PlusCircleFill,
  Trash3Fill,
  TrashFill,
  Upload,
} from "react-bootstrap-icons";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { customSingleSelectStyles } from "../../utils/constants/CustomStyles.constants";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import formatActivity from "../../utils/helpers/formatActivity";

interface CountSummary {
  id: number;
  count: string;
}

const ChangePoint: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();

  const [countData, setCountData] = useState<[]>([]);
  // const [addfolders, setAddFolders] = useState<[]>([]);
  // const [folderName, setFolderName] = useState("")
  const cmpMounted = useRef(false);
  const [postData, setPostData] = useState([]);

  const modalRef = useRef<ModalRef>(null);
  const navigate = useNavigate();
  const [count, setCount] = useState<CountSummary[]>([]);
  const [selectedValue, setSelectedValue] = useState<any>({
    id: 0,
    name: "Select Folder",
  });
  const [activity, setActivity] = useState("");
  const [countvalue, setCountvalue] = useState("");
  const [year, setYear] = useState("");
  const [id, setId] = useState<any>(null);
  const currentYear = new Date().getFullYear();
// const currentYear = 2050;
  const [showAddPointModal, setShowAddPointModal] = useState(false);
  const [showEditPointModal, setShowEditPointModal] = useState(false);
  const [SelectedActivity, setSelectedActivity] = useState<any>(null);
  const [activityError, setActivityError] = useState("");
  const [initialForm, setInitialForm] = useState<any>(null);


  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;
    fetchGetAllFolder();
  }, []);

  const fetchGetAllFolder = async (page: any = 1) => {
    try {
      dispatch(showLoader("Loading data..."));
      const payload = {
        pageSize: 10,
        pageNumber: page,
      };
      const response = await postDetails(
        APIList.LEADERBOARD_COUNT_GETALL,
        payload
      );
      console.log(response.data);
      const transformedData = response.data.map((item: any) => ({
        ...item,
        display_activity: formatActivity(item.Activity),
      }));
      console.log(transformedData);
      setCountData(transformedData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(showToast(`Some error occurred while fetching data.`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handlePost = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const editedForm = {
      point: Number(countvalue),
      year: Number(year)
    }
    
    if( JSON.stringify(initialForm) === JSON.stringify(editedForm)){
      dispatch(showToast(`No changes done.`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    try {
      dispatch(showLoader("Updating data..."));
      const payload = {
        id: id,
        point: Number(countvalue),
        Activity: activity,
        year: String(year),
      };
      // console.log(payload)
      const response = await postDetails(APIList.UPDATE_COUNT, payload);
      console.log("Response",response)
      if (response.statusCode === 200) {
        dispatch(showToast(`Points Updated Successfully.`));
        setTimeout(() => dispatch(hideToast()), 3000);
        fetchGetAllFolder();
    } else{
        dispatch(showToast(`Failed to update points.`));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
    } catch (error) {
      console.error("Error updating data:", error);
      dispatch(showToast(`Some error occurred while updating data`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
      closeEditPointModal()
      // if (modalRef.current) {
      //   modalRef.current.toggleModalWrapper(false);
      // }
    }
  };


  const handleAddPoint = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!SelectedActivity) {
       setActivityError("Select an activity")
       dispatch(showToast(`Select an activity`));
       setTimeout(() => dispatch(hideToast()), 3000);
       return;
      }
      
      setActivityError("")

    try {

      dispatch(showLoader("Adding data..."));
      const payload = {
        point: Number(countvalue),
        Activity: SelectedActivity.value, 
        year: String(selectedYear.value),
      };
      // console.log(payload)
      const response = await postDetails(APIList.UPDATE_COUNT, payload);
      // console.log("Response",response)
      if (response.statusCode === 200) {
        dispatch(showToast(`Points Added Successfully.`));
        setTimeout(() => dispatch(hideToast()), 3000);
        fetchGetAllFolder();
    } 
    else if(response.status === "Failed" || response.Status === "Failed"){
      dispatch(showToast(response.message));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
    else{
        dispatch(showToast(`Failed to add points.`));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
    } catch (error) {
      console.error("Error updating data:", error);
      dispatch(showToast(`Some error occurred while updating points`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
      closeAddPointModal()
    }
  };

  const yearOptions = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => ({
      label: `${currentYear - i}`,
      value: `${currentYear - i}`,
    })
  );


  const activityOptions = [
    { value: 'photoChallengeLike', label: 'Photo Challenge Like' },
    { value: 'videoChallengeLike', label: 'Video Challenge Like' },
    { value: 'Comment', label: 'Comment' },
    { value: 'PostLike', label: 'Post Like' },
    { value: 'videoChallenge', label: 'Video Challenge' },
    { value: 'Post', label: 'Post' },
    { value: 'photoChallenge', label: 'Photo Challenge' },
    { value: 'Zigsaw', label: 'Zigsaw' },
    { value: 'Quiz', label: 'Quiz' },
    { value: 'Training', label: 'Training' },
    { value: 'other', label: 'Other', isDisabled: true },
  ];
  

  const handleSelectedActivity = (selectedOption:any) => {
    setSelectedActivity(selectedOption); 
    console.log('Selected activity:', selectedOption);
  };
  

  const [selectedYear, setSelectedYear] = useState<any>(yearOptions[0]);

  // const selectedYearOption = yearOptions.find(
  //     (option:any) => option.value === selectedYear
  //   );

  // const handleYearChange = (selectedOption: any) => {
  //     setSelectedYear(selectedOption);
  //     console.log('Selected Year:', selectedOption.value);
  //     // Call your fetchData function or handle other logic here
  //     // fetchData(selectedOption.value);
  //   };

  const handleYearChange = (selectedOption: any) => {
    setSelectedYear(selectedOption);
    setYear(selectedOption.value); 
  };

  // const editItem = (item: any) => {
  //     console.log(item)
  //     setId(item.id)
  //     setActivity(item.Activity);
  //     setCountvalue(item.point);
  //     setYear(item.year);

  //     if (modalRef.current) {
  //         modalRef.current.toggleModalWrapper(true);
  //     }
  // };

  const editItem = (item: any) => {
    const initialFormState = {
      point: item.point,
      year: item.year,
    };

    setId(item.id);
    setActivity(item.Activity);
    setCountvalue(item.point);
  
    // Find the year in the dropdown options
    const selectedYearOption = yearOptions.find(
      (option: any) => option.value === String(item.year)
    );
    if (selectedYearOption) {
      setSelectedYear(selectedYearOption); // Update the dropdown
      setYear(selectedYearOption.value); // Set the year in the form state
    }

    setShowEditPointModal(true)
    setInitialForm(initialFormState);
  };

  const deleteItemById = async (item: any) => {
    console.log(item);
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.delete_leatherboard, {
        id: item.attendee_id,
      });
      console.log(response);
      if (response.status === "Failed") {
        dispatch(showToast(`Cannot delete user.`));
        setTimeout(() => dispatch(hideToast()), 3000);
        return;
      }
      setCountData((prevData: any) =>
        prevData.filter((row: any) => row.id !== item.id)
      );
    } catch (error) {
      console.error("Error deleting data:", error);
      dispatch(
        showToast(
          `An error occurred while trying to delete the data. Please try again.`
        )
      );
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleChangePointPopup = () => {
    if (modalRef.current) {
      modalRef.current.toggleModalWrapper(true);
    }
  };

  const closeModal = () => {
    if (modalRef.current) {
      modalRef.current.toggleModalWrapper(false);
    }
  };

  const closeAddPointModal = () => {
    setSelectedActivity(null);
    setCountvalue("");
    setActivityError("");
    setSelectedYear(yearOptions[0]);
    setShowAddPointModal(false);
  };

  const closeEditPointModal = () => {
    setSelectedActivity(null);
    setCountvalue("");
    setSelectedYear(yearOptions[0])
    setShowEditPointModal(false);
  };

  const buttons = [
    {
      label: "Add Point",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: () => {
        setShowAddPointModal(true);
      },
    },
    {
      label: "Back to Main List",
      theme: "warning",
      icon: <ArrowLeftSquareFill />,
      onClick: () => {
        navigate("/leaderboard");
      },
    },
  ];

  const columns: TableColumn[] = [
    {
      key: "display_activity",
      label: "Activity ",
      sortable: true,
      dataType: "string",
    },
    { key: "year", label: "Year", dataType: "string" },
    { key: "point", label: "Point", dataType: "string" },
  ];


  return (
    <LayoutContainer title="leaderboard">
      {/* <ModalWrapper ref={modalRef} title={"Add Count"}> */}
      <Modal
        show={showEditPointModal}
        onHide={closeEditPointModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Point</Modal.Title>
        </Modal.Header>
        <Modal.Body
        // style={{overflowY:"visible"}}
        >
        <form onSubmit={handlePost}>
          <div className="row">
            <div className="col-12">
              <InputField
                name="activity_name"
                label="Activity Name"
                type="text"
                value={formatActivity(activity)}
                onChangeInput={(e) => setActivity(e.target.value)}
                minLength={1}
                maxLength={50}
                disabled
              />
            </div>
            <div className="col-6 my-4 height-50px">
              <InputField
                name="point"
                label="Point"
                type="text"
                value={countvalue}
                onChangeInput={(e) => setCountvalue(e.target.value)}
                minLength={1}
                maxLength={10}
                required={true}
              />
            </div>
            <div className="col-6 my-4" style={{ fontSize: "11.2px" }}>
              {/* <InputField
                                name="year"
                                label="Year"
                                type="text"
                                value={year}
                                onChangeInput={(e) => setYear(e.target.value)}
                                minLength={1}
                                maxLength={50}
                                disabled
                            /> */}
              <label htmlFor="year" className="mb-1">
                Year
              </label>
              <Select
                id="year"
                name="year"
                styles={customSingleSelectStyles}
                value={selectedYear}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={false}
                placeholder="Select Year"
                className="font-13"
              />
            </div>
          </div>
          <CustomButton type="submit" size="md" theme="yellow">
            Submit
          </CustomButton>
        </form>
      {/* </ModalWrapper> */}
      </Modal.Body>
      </Modal>

      <Modal
        show={showAddPointModal}
        onHide={closeAddPointModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Point</Modal.Title>
        </Modal.Header>
        <Modal.Body
        // style={{overflowY:"visible"}}
        >
          <form
            onSubmit={(ev) => {
              handleAddPoint(ev);
            }}
          >
            <div className="row">
              <div className="col-12" style={{ height: "88px"}}>
                {/* <InputField
                  name="activity_name"
                  label="Activity Name"
                  type="text"
                  value={activity}
                  onChangeInput={(e) => setActivity(e.target.value)}
                  minLength={1}
                  maxLength={50}
                  disabled
                /> */}
                <label htmlFor="year" className="mb-1 font-12 weight-500">
                  Select Activity <span className="text-danger">*</span>
                </label>
                <Select
                  id=""
                  name="activity_name"
                  styles={customSingleSelectStyles}
                  value={SelectedActivity}
                  onChange={handleSelectedActivity}
                  options={activityOptions}
                  isSearchable={false}
                  placeholder="Select Activity"
                  className="font-13"
                />
                { activityError && <span className="error-text font-12">{activityError}</span> }
              </div>
              <div className="col-6 my-4 height-50px">
                <InputField
                  name="point"
                  label="Point"
                  type="text"
                  value={countvalue}
                  onChangeInput={(e) => setCountvalue(e.target.value)}
                  minLength={1}
                  maxLength={10}
                  required={true}
                />
              </div>
              <div className="col-6 my-4" style={{ fontSize: "11.2px" }}>
                <label htmlFor="year" className="mb-1 weight-500">
                  Year
                </label>
                <Select
                  id="year"
                  name="year"
                  styles={customSingleSelectStyles}
                  value={selectedYear}
                  onChange={handleYearChange}
                  options={yearOptions}
                  isSearchable={false}
                  placeholder="Select Year"
                  className="font-13"
                />
              </div>
            </div>
            <div>
              <CustomButton theme="yellow" type="submit" size="md">
                Submit
              </CustomButton>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Change Point
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div>
        <CommonTable<any>
          data={countData}
          columns={columns}
          onEdit={editItem}
          onDelete={deleteItemById}
          pagination={true}
          rowsPerPage={10}
          actions={{
            view: false,
            edit: true,
            delete: false,
            checkbox: false,
            status: false,
            showModal: false,
          }}
        />
      </div>
    </LayoutContainer>
  );
};

export default ChangePoint;
